import { FC, HTMLProps } from 'react'

import { cn } from 'src/lib/cn'
import { cva, type VariantProps } from 'src/lib/cva'

const IconButtonVariants = cva(
  'flex cursor-pointer items-center justify-center border border-grey text-grey rounded-full transition-all duration-200 ease-in-out size-8 hover:bg-alto hover:border-alto hover:text-black',
  {
    variants: {
      disabled: {
        true: 'pointer-events-none cursor-default opacity-80 grayscale-50',
      },
      noBorder: {
        true: 'border-none text-[22px]',
      },
    },
    defaultVariants: {
      disabled: false,
      noBorder: false,
    },
  },
)

export type IconButtonProps = HTMLProps<HTMLDivElement> & VariantProps<typeof IconButtonVariants>

const IconButton: FC<IconButtonProps> = ({
  children,
  disabled,
  noBorder,
  className,
  onClick,
  ...divProps
}) => (
  <div
    className={cn(IconButtonVariants({ disabled, noBorder }), className)}
    role="button"
    onClick={!disabled && typeof onClick === 'function' ? onClick : () => null}
    onMouseDown={event => event.stopPropagation()}
    {...divProps}
  >
    {children}
  </div>
)

export default IconButton
